export default function HeroSection() {
  return (
    <section className="w-full bg-background-50 pt-32 md:pt-40 pb-28 md:pb-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-20 lg:px-[100px]">
        <h1 className="font-heading text-5xl md:text-7xl lg:text-[80px] font-bold text-foreground-950 leading-[1.05] tracking-tight">
          VYTENIS TECH, MB
        </h1>
        <div className="mt-10 md:mt-12 max-w-[720px]">
          <p className="font-body text-lg md:text-xl text-foreground-600 leading-relaxed">
            A professional engineering team focused on designing and developing modern digital
            software solutions for the iOS platform and related technologies. We build scalable,
            maintainable, and high-performance systems with a strong focus on usability, stability,
            and long-term technical quality.
          </p>
        </div>
      </div>
    </section>
  );
}